<template>
  <node :config="config" :title="config.name" :show-error="showError" :content="content" :error-info="errorInfo"
        @selected="$emit('selected')" @delNode="$emit('delNode')" @insertNode="type => $emit('insertNode', type)"
        placeholder="请选择子流程" :header-bgc="headerBgc" header-icon="el-icon-s-check"/>
</template>
<script>
import Node from './Node'

export default {
  name: 'SubprocessNode',
  inject: ['$workflow'],
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {Node},
  data () {
    return {
      showError: false,
      errorInfo: ''
    }
  },
  computed: {
    headerBgc () {
      if (this.$workflow.diagramMode === 'viewer') {
        return this.config.props.headerBgc
      } else {
        return '#9274e7'
      }
    },
    content () {
      const props = this.config.props
      const subprocess = props.subprocess
      if (subprocess) {
        let title
        if (props.versionType === 'BINDING') {
          title = `${subprocess.name} - 第${subprocess.version}版`
        } else {
          title = subprocess.name
        }
        return `发起流程：${title}`
      }
    }
  },
  methods: {
    validate (err) {
      const props = this.config.props
      this.showError = false

      if (!props.subprocess) {
        this.errorInfo = '请选择子流程'
        err.push(`${this.config.name} 未选择子流程`)
        this.showError = true
        return this.showError
      }

      if (props.initiatorType === 'ASSIGN_USER' && !props.subInitiator) {
        this.errorInfo = '请指定发起人'
        err.push(`${this.config.name} 指定人员发起但未选择人员`)
        this.showError = true
      }

      return this.showError
    }
  }
}
</script>
